module.exports = __webpack_public_path__ + "img/rz10.2bc981f8.jpeg";